import React from "react"
import I18n from 'i18n-js';
import '../../translations.js';

export class PersonResultTable extends React.Component{
  constructor(props) {
    super(props);
    this.handleAddPerson = this.handleAddPerson.bind(this);
  }

  handleAddPerson(e) {
    var person = {id: e.id, name: e.name}
    this.props.addPerson(person, this.props.target)
  }

  render () {
    return (
      <table className="table table-striped">
        <thead>
          <tr>
            <th>{ I18n.t("name") }</th>
            <th>{ I18n.t("activerecord.attributes.address.province") }</th>
            <th>{ I18n.t("email") }</th>
            <th>{ I18n.t("exhibitor.type_of_account") }</th>
            <th>{ I18n.t("exhibitor.exhibitor_word") }</th>
          </tr>
        </thead>
        <tbody>
          {this.props.results.map((result, index) =>
            <tr key={index}>
              <td>{result.name}</td>
              <td>{result.postal_code}</td>
              <td>{result.email}</td>
              <td>{result.type}</td>
              <td>{result.exhibitor}</td>
              { this.props.addPerson
                ? <td><a className="btn btn-primary" onClick={() => { this.handleAddPerson(result) }}>{ I18n.t("exhibitor.person_search_results.enter") }<br/>{ I18n.t("exhibitor.person_search_results.this") }<br/>{this.props.entity}</a></td>
                : undefined
              }
            </tr>
            )
          }
        </tbody>
      </table>
      )
  }
}
